var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"allow",attrs:{"id":_vm.id,"cancel-title":_vm.$t('_cancel')},on:{"ok":_vm.confirm}},[_vm._v("\n  "+_vm._s(_vm.question)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }